import { FC, useEffect, useState } from "react";
import { Row } from "../../../components/containers";
import { IconAnimation } from "../../../components/animation";
import {
  BrowserIcon,
  DiscordIcon,
  InstagramIcon,
  TelegramIcon,
  TwitterIcon,
} from "../../../assets/icons";
import { MAX_MOBILE_WIDTH } from "../../../constants";

const Socials: FC = () => {
  const [conStyle, setConStyle] = useState<React.CSSProperties>(
    styles.container
  );

  const onWindowResize = (): void => {
    if (window.innerWidth < MAX_MOBILE_WIDTH)
      setConStyle(styles.mobileContainer);
    else setConStyle(styles.container);
  };

  useEffect(() => {
    onWindowResize();
    window.addEventListener("resize", onWindowResize);
    return (): void => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  return (
    <Row style={conStyle} gap={5}>
      <IconAnimation
        Icon={TelegramIcon}
        onHoverColor={"#1D90F5"}
        width={20}
        height={20}
        className="cursor-pointer"
      />
      <IconAnimation
        Icon={InstagramIcon}
        onHoverColor={"#F9A825"}
        width={20}
        height={20}
        className="cursor-pointer"
      />
      <IconAnimation
        Icon={TwitterIcon}
        onHoverColor={"white"}
        width={20}
        height={20}
        className="cursor-pointer"
      />
      <IconAnimation
        Icon={BrowserIcon}
        onHoverColor={"#1D90F5"}
        width={20}
        height={20}
        className="cursor-pointer"
      />
      <IconAnimation
        Icon={DiscordIcon}
        onHoverColor={"#7289da"}
        width={20}
        height={20}
        className="cursor-pointer"
      />
    </Row>
  );
};

export default Socials;

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "absolute",
    top: "1.5rem",
    right: "5rem",
    zIndex: 99,
  },
  mobileContainer: {
    position: "absolute",
    top: "1.5rem",
    right: "50%",
    transform: "translate(50%)",
    zIndex: 99,
  },
};
